import React from 'react'
import { Typography, Modal, Button, Icon, Row, Col } from 'antd'

const { Text, Title } = Typography


class IframeFile extends React.PureComponent {
	
	state = {
		srcLink: null
    }

	base64ToBlob = (base64, type = "application/octet-stream" ) => {
		const bytes = atob(base64);
		let length = bytes.length;
		let out = new Uint8Array(length);

		while (length--) {
			out[length] = bytes.charCodeAt(length);
		}

		return new Blob([out], { type: 'application/pdf' });
	}

	async componentDidMount() {
		const { typeFile, file } = this.props

		const fileTwoBase64 = file
		const pdfTwo = document.getElementById('pdf-two')
		const blob = this.base64ToBlob( fileTwoBase64, 'application/pdf' );
		const url = URL.createObjectURL( blob );
		this.setState({
			srcLink: url
		})
    }

	render() {
		const { typeFile, file, showPdfFild = false , formUpload = false } = this.props
		const { srcLink} = this.state
		
		console.log('srcLink',formUpload)
		return (
			<>
            {
               formUpload ?
                  <Row  gutter={16} type="flex" justify="left" align="top" >
                     <Col span={8} style={{ display:"block"}}>
                        <div style={{ width:"100%", height: "200px" }} align="center" className="block-show-image-modal">
                           <a href={srcLink} className="color-white" target="_blank">
                              <Icon type="file-pdf" /><br></br>
                              ดูไฟล์ PDF
                           </a>
                        </div>
                     </Col>
                  </Row>
               :
                  <div>
                     {
                        srcLink &&
                           <>
                              {
                                 showPdfFild ? 
                                    <a href={srcLink} className="color-white" target="_blank" >
                                       <Icon type="file-pdf" /><br></br>
                                       ดูไฟล์ PDF
                                    </a>
                                 :
                                 <div className="mt-5">
                                    <a href={srcLink} title='Download pdf document' className="mt-3 color-red" target="_blank" style={{ textDecoration: "underline" }}>คลิกเพื่อดูเอกสาร</a>
                                 </div>
                              }
                           </>
                        }
                  </div>
            }
			</>
		)
	}
}

export default IframeFile